function Warning() {
  var tmp = Error.apply(this, arguments);
  tmp.name = this.name = 'Warning';

  this.message = tmp.message;
  Object.defineProperty(this, 'stack', { // getter for more optimizy goodness
    get: function() {
      return tmp.stack;
    }
  });

  return this;
}

module.exports = Warning;